<template>
  <div class="position-slots-modal">
    <div class="slots-container">
      <h3 class="modal-title">סלוטים של משרה</h3>

      <!-- Position Info -->
      <div class="position-info">
        <div class="info-row">
          <strong>משרה:</strong> {{ position.title }}
        </div>
        <div class="info-row">
          <strong>Publish Outsources:</strong>
          <span class="publish-outsources">{{ position.publish_outsources || 'N/A' }}</span>
        </div>
      </div>

      <!-- Loading State -->
      <div v-if="is_loading" class="loading-container">
        <i class="fas fa-spinner fa-spin"></i>
        <span>טוען סלוטים...</span>
      </div>

      <!-- Slots List -->
      <div v-else-if="slots.length > 0" class="slots-list">
        <div v-for="slot in sortedSlots" :key="slot.id" class="slot-card">
          <div class="slot-header">
            <h4>{{ slot.supplier_name }}</h4>
            <span class="slot-status" :class="'status-' + slot.status">{{ slot.status }}</span>
          </div>
          <div class="slot-details">
            <div class="detail-row">
              <i class="far fa-clock"></i>
              <span>עדכון אחרון: {{ formatDate(slot.updated_at) }}</span>
            </div>
            <div v-if="slot.remote_position_id" class="detail-row">
              <i class="fas fa-link"></i>
              <span>Remote ID: {{ slot.remote_position_id }}</span>
            </div>
          </div>
          <div class="slot-actions">
            <button
              @click="showLoginDetails(slot.supplier.id)"
              class="button is-primary login-details-button"
              title="פרטי התחברות"
            >
              <span class="icon"><i class="fas fa-key"></i></span>
              <span>פרטי התחברות</span>
            </button>
            <button
              @click="replaceSlot(slot)"
              class="button is-info replace-button"
              :disabled="slot.status !== 'active'"
            >
              <span class="icon"><i class="fas fa-exchange-alt"></i></span>
              <span>החלף סלוט</span>
            </button>
          </div>
        </div>
      </div>

      <!-- No Slots -->
      <div v-else class="no-slots">
        <p>אין סלוטים למשרה זו</p>
      </div>
    </div>

    <div class="modal-actions">
      <button @click="close" class="button is-light">
        <span class="icon"><i class="fas fa-times"></i></span>
        <span>סגור</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'PositionSlotsModal',
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      slots: [],
      is_loading: false
    }
  },
  computed: {
    position () {
      // The modal system passes the entire configuration as payload
      // The actual data is in payload.payload
      return (this.payload.payload && this.payload.payload.position) || this.payload.position || {}
    },
    env () {
      return this.$settings.get({ path: 'app_name' })
    },
    sortedSlots () {
      return [...this.slots].sort((a, b) => {
        if (a.status === 'active' && b.status !== 'active') {
          return -1
        }
        if (a.status !== 'active' && b.status === 'active') {
          return 1
        }
        return 0
      })
    }
  },
  created () {
    console.log('PositionSlotsModal created with payload:', this.payload)
    console.log('Payload keys:', Object.keys(this.payload))
    console.log('Payload.position:', this.payload.position)
    if (this.payload.position) {
      console.log('Position keys:', Object.keys(this.payload.position))
    }
    this.loadSlots()
  },
  methods: {
    async loadSlots () {
      console.log('Loading slots for position:', this.position)
      console.log('Position shuffle_position_id:', this.position.shuffle_position_id)
      console.log('Position id:', this.position.id)
      console.log('Env:', this.env)

      const position_id = this.position.shuffle_position_id || this.position.id
      console.log('Using position_id:', position_id)

      this.is_loading = true
      try {
        const result = await this.$network_utils.caller.request(
          'get',
          '/shuffle_positions/slots',
          'admin_headers',
          {
            position_id: position_id,
            env: this.env
          }
        )
        console.log('Slots result:', result)
        this.slots = Array.isArray(result) ? result : ((result && result.data) || result || [])
      } catch (error) {
        console.error('Error loading slots:', error)
        console.error('Error details:', error.response || error.message)
        this.$utils.emit('show_toast', { text: 'שגיאה בטעינת סלוטים: ' + (error.message || 'Unknown error'), type: 'error' })
        this.slots = []
      } finally {
        this.is_loading = false
      }
    },
    replaceSlot (slot) {
      // Open position search modal for slot replacement
      this.create({
        designator: 'slot-replace-position-search',
        component_name: 'PositionSearchForCvModal',
        modal_width: 900,
        payload: {
          mode: 'slot_replacement',
          currentPosition: this.position,
          slot: slot,
          onPositionSelected: async (selectedPosition) => {
            try {
              // Step 1: Validate replacement BEFORE executing
              const validation = await this.$network_utils.caller.request(
                'get',
                '/shuffle_positions/validate_supplier',
                'admin_headers',
                {
                  env: this.env,
                  env_position_id: selectedPosition.id,
                  supplier_name: slot.supplier_name
                }
              )

              // Check validation result - API returns {exists: true} when supplier IS compatible
              if (!validation || !validation.exists) {
                this.$utils.emit('show_toast', {
                  text: 'הספק אינו תואם למשרה זו. אנא בחר משרה אחרת.',
                  type: 'error',
                  duration: 8000
                })
                return // Stop - don't proceed with replacement
              }

              // Step 2: Validation passed - execute replacement
              const result = await this.$network_utils.caller.request(
                'post',
                '/shuffle_positions/replace_slot',
                'admin_headers',
                {
                  id: slot.id,
                  env: this.env,
                  env_position_id: selectedPosition.id
                }
              )

              if (result && result.success) {
                this.$utils.emit('show_toast', {
                  text: result.message || 'הבקשה להחלפת הסלוט נשלחה בהצלחה ומתבצעת ברקע',
                  type: 'info',
                  duration: 8000
                })

                // Refresh slots after delay to show updated status
                setTimeout(() => {
                  this.loadSlots()
                }, 2000)

                const onSuccess = (this.payload.payload && this.payload.payload.onSuccess) || this.payload.onSuccess
                if (onSuccess) {
                  onSuccess()
                }
              } else {
                this.$utils.emit('show_toast', {
                  text: result.error || 'שגיאה בהחלפת הסלוט',
                  type: 'error'
                })
              }
            } catch (error) {
              console.error('Error replacing slot:', error)

              let errorMessage = 'שגיאה בהחלפת הסלוט'
              let errorDetails = ''

              if (error.response && error.response.data) {
                const errorData = error.response.data
                if (errorData.error) {
                  errorMessage = errorData.error
                }
                if (errorData.details) {
                  errorDetails = `\n\nפרטים: ${errorData.details}`
                }
              } else if (error.message) {
                errorMessage = error.message
              }

              this.$utils.emit('show_toast', {
                text: errorMessage + errorDetails,
                type: 'error',
                duration: 8000
              })
            }
          }
        },
        modal_title: `החלף סלוט - ${slot.supplier_name}`
      })
    },
    copyToClipboard (text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$utils.emit('show_toast', {
          text: 'הועתק ללוח',
          type: 'success',
          duration: 2000
        })
      }).catch(err => {
        console.error('Error copying to clipboard:', err)
        this.$utils.emit('show_toast', {
          text: 'שגיאה בהעתקה',
          type: 'error'
        })
      })
    },
    async showLoginDetails (supplierId) {
      try {
        const loginDetails = await this.$network_utils.caller.request(
          'get',
          `/shuffle_positions/supplier_login_details?id=${supplierId}`,
          'admin_headers'
        )

        if (loginDetails.supplier_name === 'AllJobs') {
          this.$utils.emit('show_toast', {
            text: 'אין מידע זמין עבור AllJobs',
            type: 'info',
            duration: 3000
          })
          return
        }

        this.create({
          designator: 'supplier-login-details',
          component_name: 'SupplierLoginDetailsModal',
          modal_title: `פרטי התחברות - ${loginDetails.supplier_name}`,
          modal_width: 650,
          payload: {
            loginDetails: loginDetails
          }
        })
      } catch (error) {
        console.error('Error fetching login details:', error)
        this.$utils.emit('show_toast', {
          text: 'שגיאה בטעינת פרטי התחברות',
          type: 'error'
        })
      }
    },
    formatDate (dateString) {
      if (!dateString) return 'N/A'
      const date = new Date(dateString)
      return date.toLocaleString('he-IL', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },
    close () {
      this.remove(this.payload)
    },
    ...mapMutations('modals', ['create', 'remove'])
  }
}
</script>

<style scoped>
.position-slots-modal {
  padding: 24px;
  direction: rtl;
  text-align: right;
  width: 900px;
  max-width: 95vw;
  background-color: #ffffff;
  border-radius: 12px;
}

.slots-container {
  margin-bottom: 24px;
}

.modal-title {
  font-size: 24px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 16px;
  text-align: center;
}

.position-info {
  background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 24px;
  border: 2px solid #2196f3;
}

.info-row {
  margin-bottom: 8px;
  font-size: 14px;
  color: #424242;
}

.info-row:last-child {
  margin-bottom: 0;
}

.publish-outsources {
  background-color: #fff;
  padding: 2px 8px;
  border-radius: 4px;
  font-family: monospace;
  font-size: 13px;
  border: 1px solid #2196f3;
}

.loading-container {
  text-align: center;
  padding: 40px;
  color: #7f8c8d;
}

.loading-container i {
  font-size: 32px;
  margin-bottom: 16px;
  display: block;
}

.slots-list {
  display: grid;
  gap: 16px;
}

.slot-card {
  background-color: #f8f9fa;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s;
}

.slot-card:hover {
  border-color: #3498db;
  box-shadow: 0 2px 8px rgba(52, 152, 219, 0.2);
}

.slot-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e9ecef;
}

.slot-header h4 {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  color: #2c3e50;
}

.slot-status {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.status-active {
  background-color: #d4edda;
  color: #155724;
}

.status-expired {
  background-color: #f8d7da;
  color: #721c24;
}

.status-pending_shuffle_out,
.status-pending_review,
.status-pending_remote_position_id {
  background-color: #fff3cd;
  color: #856404;
}

.slot-details {
  margin-bottom: 12px;
}

.detail-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  font-size: 14px;
  color: #6c757d;
}

.detail-row i {
  width: 16px;
  text-align: center;
}

.replace-button {
  width: 100%;
  font-weight: 500;
}

.replace-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.no-slots {
  text-align: center;
  padding: 40px;
  color: #7f8c8d;
  font-style: italic;
}

.modal-actions {
  display: flex;
  justify-content: center;
  gap: 16px;
  padding-top: 16px;
  border-top: 1px solid #e9ecef;
}

.button {
  min-width: 120px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.button.is-info {
  background-color: #3498db;
  border-color: #3498db;
  color: white;
}

.button.is-info:hover:not(:disabled) {
  background-color: #2980b9;
  border-color: #2980b9;
}

.button.is-light {
  background-color: #ecf0f1;
  border-color: #bdc3c7;
  color: #2c3e50;
}

.button.is-light:hover {
  background-color: #d5dbdb;
  border-color: #95a5a6;
}

.icon {
  margin-left: 8px;
}
</style>
